var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block",class:("text-" + _vm.color + " " + _vm.rotate)},[_c(_vm.icon,{tag:"component",attrs:{"width":_vm.size,"height":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }